import { CharacterTabs } from '@/components/features/characters'
import { AnimatedOutlet } from '@/components/ui'

/**
 * Section wrapper for the /characters area. Mirrors `VideoPage` and
 * `ImagesPage`: renders the section tab nav at top and an
 * `AnimatedOutlet` for the active sub-route's content. Today the only
 * sub-route is the create flow; future entries (e.g. Image to
 * Character) drop in as additional children without restructuring.
 */
export function CharactersPage() {
  return (
    <div>
      <div className="px-6 md:px-8 pt-6">
        <CharacterTabs />
      </div>
      <AnimatedOutlet />
    </div>
  )
}
